import { component } from 'picoapp';
import { setProgressWidth, updateProgress } from 'utils/slider';

export default component((node) => {
  const triggers = node.querySelectorAll('[data-trigger]');
  const wrappers = node.querySelectorAll('[data-wrapper]');

  const initSlider = async (wrapper) => {
    if (!(wrapper instanceof HTMLElement)) return;

    const { default: KeenSlider } = await import(/* webpackChunkName: "keen-slider" */ 'keen-slider');

    const slider = wrapper.querySelector('[data-slider]');
    const prev = wrapper.querySelector('[data-prev]');
    const next = wrapper.querySelector('[data-next]');

    const progress = wrapper.querySelector('[data-progress]');
    const progressBar = wrapper.querySelector('[data-progress-bar]');

    /* eslint-disable @typescript-eslint/no-unused-expressions */
    function updateClasses(instance) {
      const { relativeSlide, size, slidesPerView: items } = instance.details();

      if (prev) relativeSlide === 0 ? prev.classList.add('is-disabled') : prev.classList.remove('is-disabled');
      if (next) Math.floor(relativeSlide + items) === size ? next.classList.add('is-disabled') : next.classList.remove('is-disabled');
    }
    /* eslint-enable @typescript-eslint/no-unused-expressions */

    // eslint-disable-next-line no-new
    new KeenSlider(slider, {
      slidesPerView: 1.3,
      spacing: 20,
      duration: 1200,
      breakpoints: {
        '(min-width: 768px)': {
          slidesPerView: 3,
          spacing: 30,
        },
        '(min-width: 1024px)': {
          slidesPerView: 4,
        },
        '(min-width: 1536px)': {
          slidesPerView: 5,
        },
      },
      created(instance) {
        slider.classList.add('is-loaded');

        if (prev) prev.addEventListener('click', () => instance.prev());
        if (next) next.addEventListener('click', () => instance.next());

        setProgressWidth(instance, progressBar);
        updateClasses(instance);
      },

      move(instance) {
        updateProgress(instance, progressBar, progress);
      },

      slideChanged(instance) {
        updateClasses(instance);
      },
    });
  };

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const { trigger: gender } = trigger.dataset;

      triggers.forEach((el) => el.classList.remove('is-active'));
      trigger.classList.add('is-active');

      const relatedWrapper = [...wrappers].find((wrapper) => wrapper.dataset.gender === gender);
      const unrelatedWrappers = [...wrappers].filter((wrapper) => wrapper !== relatedWrapper);

      relatedWrapper.hidden = false;
      initSlider(relatedWrapper);

      unrelatedWrappers.forEach((wrapper) => {
        wrapper.hidden = true;
      });
    });
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        initSlider([...wrappers].find((wrapper) => !wrapper.hidden));
        observer.disconnect(node);
      }
    });
  }, {
    rootMargin: '100px',
  });

  observer.observe(node);
});
